import { ChangeDetectionStrategy, Component, inject, input, output, signal } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { ThemePalette } from '@angular/material/core';
import { MatIconModule } from '@angular/material/icon';
import { Router } from '@angular/router';
import { BreadcrumbStore } from '@workspace/ng-data-access';
import { AvatarAuraComponent } from '../../../media/avatar/avatar.component';

export interface HeaderOptions {
  drawer?: boolean;
  refresh?: boolean;
  buttons?: [
    {
      label: string;
      icon: string | null;
      disabled: boolean;
      action: string;
      color: ThemePalette;
      variant: string;
    },
  ];
}

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'aura-breadcrumb-navigation',
  templateUrl: './breadcrumb-navigation.component.html',
  imports: [MatIconModule, MatButtonModule, AvatarAuraComponent],
})
export class AuraBreadcrumbNavigationComponent {
  readonly options = input<HeaderOptions>();
  readonly toggleDrawer = output<void>();
  readonly toggleRefresh = output<void>();
  readonly toggleAction = output<string>();
  readonly refreshStateDisabled = signal(false);
  protected breadcrumbStore = inject(BreadcrumbStore);
  private readonly router = inject(Router);

  constructor() {
    // effect(() => console.log('breadcrumbStore', this.breadcrumbStore.navigationPaths())); // debug
  }

  goBack(): void {
    const paths = this.breadcrumbStore.navigationPaths();
    const previous = paths.at(-2);
    if (previous) {
      void this.router.navigate([previous.path]);
    }
  }

  toggleButtonAction(action: string): void {
    this.toggleAction.emit(action);
  }

  toggleRefreshAction(): void {
    this.toggleRefresh.emit();
    this.refreshStateDisabled.set(true);
    setTimeout(() => this.refreshStateDisabled.set(false), 1000);
  }

  toggleDrawerAction(): void {
    this.toggleDrawer.emit();
  }

  goTo(path: string) {
    void this.router.navigate([path]);
  }
}
